import React from 'react';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

import ModalHeader from '../common/modal/header';

class LoadingModal extends React.Component {
    render = () => {
        const { t } = this.props;
        return (
            <div>
                <ModalHeader
                    headerText={t('confirming_order')}
                    hideCloseButton
                />
                <div className="m2g-modal-body m2g-order-payment-redirect-loading-modal-body">
                    <div className="m2g-icon m2g-icon--spinner m2g-icon--medium" />
                </div>
            </div>
        );
    };
}

export default forwardRefWithTranslation('order.confirmation')(LoadingModal);
